import { Offer } from '../../ContentfulTypes';
import { InventoryStatus, ReserveStatus } from '../../types';

// todo: autogenerate these types
// these definitions are partials of the actual type
export type FormattedPhone = {
  availableOffers: Offer[];
  reserveStatus: ReserveStatus;
  enableReserveButton?: boolean;
  disablePhoneReservation?: boolean;
  displayName: string;
};

export enum ButtonType {
  Reserve = 'reserve',
  Chat = 'chat',
  None = '',
}

export type InventoryItem = {
  productSku: string;
  status: InventoryStatus;
  quantity: number
};

export type PhoneLabel = {
  contentful_id: string;
  displayLabel: string;
  placeholderLabel: string;
};
